import { invoiceUploadError, MAX_INVOICE_BYTES } from './invoiceUpload';

export const ESAVE_PATH = '/esave';
export const WHATSAPP_ATTACHMENT_PARAM = 'whatsapp_attachment';

export function whatsappInvoiceHref(id) {
    return `${ESAVE_PATH}?${new URLSearchParams({ [WHATSAPP_ATTACHMENT_PARAM]: id })}`;
}

export async function whatsappInvoiceFile(authFetch, id) {
    const response = await authFetch(`/api/whatsapp/download/${encodeURIComponent(id)}`);
    if (!response.ok) throw new Error('No se ha podido recuperar el adjunto de WhatsApp');
    if (Number(response.headers.get('Content-Length')) > MAX_INVOICE_BYTES) {
        throw new Error('El archivo supera los 16 MB');
    }
    const blob = await response.blob();
    const type = (response.headers.get('Content-Type') || blob.type).split(';')[0].trim().toLowerCase();
    const suffix = { 'application/pdf': '.pdf', 'image/jpeg': '.jpg', 'image/png': '.png' }[type];
    if (!suffix) throw new Error('Selecciona un PDF, JPG, JPEG o PNG');
    const disposition = response.headers.get('Content-Disposition') || '';
    const filename = /filename="([^"]+)"/i.exec(disposition)?.[1]?.split(/[\\/]/).pop() || 'factura-whatsapp';
    const file = new File([blob], /\.(pdf|jpe?g|png)$/i.test(filename) ? filename : filename + suffix, { type });
    const failure = invoiceUploadError([file]);
    if (failure) throw new Error(failure);
    return file;
}
